/**
 * Ключи запросов витрины. Собраны в одном месте, чтобы инвалидация после
 * изменения попадала ровно в те запросы, которые устарели: `['cart']`
 * накрывает корзину и её итоги, `['orders', id]` — только один заказ.
 */
export const keys = {
  settings: ['settings'] as const,

  categories: ['categories'] as const,
  products: (query: Record<string, unknown>) => ['products', query] as const,
  product: (id: number) => ['products', id] as const,
  /** Карточки по номерам (избранное); номера — по возрастанию. */
  productsByIds: (ids: number[], lang: string) => ['products', 'byIds', ids, lang] as const,
  popular: ['products', 'popular'] as const,
  availability: (id: number) => ['products', id, 'availability'] as const,
  /** Наличие выбранного в мультипоиске одним запросом; номера — по возрастанию. */
  multiAvailability: (ids: number[]) => ['products', 'availability', ids] as const,
  similar: (id: number) => ['products', id, 'similar'] as const,
  /** Подсказки мультипоиска: одна страница по строке, отдельно от ленты каталога. */
  suggest: (q: string, lang: string) => ['products', 'suggest', q, lang] as const,

  stores: ['stores'] as const,

  cart: ['cart'] as const,
  checkoutOptions: ['checkout', 'options'] as const,
  quote: (query: Record<string, unknown>) => ['checkout', 'quote', query] as const,

  orders: ['orders'] as const,
  order: (id: number) => ['orders', id] as const,

  loyalty: ['loyalty'] as const,
  transactions: ['loyalty', 'transactions'] as const,
  addresses: ['addresses'] as const,
  cards: ['cards'] as const,

  /** Всё центра уведомлений: и список, и счётчик — после «прочитано» устаревают вместе. */
  notifications: ['notifications'] as const,
  inbox: ['notifications', 'inbox'] as const,
  unread: ['notifications', 'unread'] as const,

  /** PIN-код и биометрия Flutter-оболочки: свои у каждого аккаунта. */
  nativeSecurity: (customerId: number) => ['native-security', customerId] as const,

  /** Сторис на главной: язык выбирает экран, поэтому в ключе его нет. */
  stories: ['stories'] as const,

  /** Новости: лента, полка главной и экран новости. Язык выбирает экран — в ключах его нет. */
  news: ['news'] as const,
  newsList: ['news', 'list'] as const,
  newsLatest: (limit: number) => ['news', 'latest', limit] as const,
  newsItem: (id: number) => ['news', 'item', id] as const,

  /**
   * Оценки заказов: ожидающие оценки и оценка одного заказа. После оценки или
   * «не сейчас» устаревают вместе — `['reviews']` накрывает всё.
   */
  reviews: ['reviews'] as const,
  reviewsPending: ['reviews', 'pending'] as const,
  orderReview: (orderId: number) => ['reviews', 'order', orderId] as const,

  /**
   * Избранное: список гостя живёт в браузере, вошедшего — на сервере
   * (или в том же браузере, пока ручек нет). `['favorites']` накрывает оба.
   */
  favorites: ['favorites'] as const,
  favoritesList: (source: 'local' | 'api') => ['favorites', source] as const,

  /** Текстовая страница из админки (политика, соглашение) на языке интерфейса. */
  page: (slug: string, lang: string) => ['pages', slug, lang] as const,
} as const
